const NODE_ENV=process.env.NODE_ENV;
const API_URL=process.env.REACT_APP_API_URL;
const PHP_API_URL=process.env.REACT_APP_PHP_API_URL;
const WEBSITE_URL=process.env.REACT_APP_WEBSITE_URL;
const PRODUCT_NAME=process.env.REACT_APP_PRODUCT_NAME || "Kanak Loans";
const EMAIL_ID=process.env.REACT_APP_EMAIL_ID;
const MOBILES=process.env.REACT_APP_MOBILES ? process.env.REACT_APP_MOBILES.split(",") : [];
const NBFC_NAME=process.env.REACT_APP_NBFC_NAME || "Agrim Fincap Private Limited";
const API_PRODUCT_NAME=process.env.REACT_APP_API_PRODUCT_NAME || "kanakloans_api";

const ROZAR_PAY_KEY=process.env.REACT_APP_ROZAR_PAY_KEY;
const ROZAR_PAY_SDK_URL=process.env.REACT_APP_ROZAR_PAY_SDK_URL;
const PAYU_SDK_URL=process.env.REACT_APP_PAYU_SDK_URL;
const ROZAR_PAY_REPAYMENT_KEY_NAME=process.env.REACT_APP_RAZORPAY_REPAYMENT_KEY_NAME || "RazorPay Repayment";
const ROZAR_PAY_EMANDATE_KEY_NAME=process.env.REACT_APP_RAZORPAY_EMANDATE_KEY_NAME || "RazorPay Emandate";

export {
  NODE_ENV,
  API_URL, 
  PHP_API_URL,
  WEBSITE_URL,
  PRODUCT_NAME,
  EMAIL_ID,
  MOBILES,
  NBFC_NAME,
  API_PRODUCT_NAME,
  ROZAR_PAY_SDK_URL,
  PAYU_SDK_URL,
  ROZAR_PAY_REPAYMENT_KEY_NAME,
  ROZAR_PAY_EMANDATE_KEY_NAME,
  ROZAR_PAY_KEY,
};

